// Intro
export const INTRO_TITLE_LINE1 = 'Выбирай и покупай';
export const INTRO_TITLE_LINE2 = 'туры онлайн';
export const INTRO_TITLE = 'ВЫБИРАЙ И ПОКУПАЙ ТУРЫ ОНЛАЙН';
// served from public/, preloaded in public/index.html
export const INTRO_BG_IMAGE = '/images/bg-main.webp';
export const INTRO_SUBTITLE =
  'по ценам туроператоров или ниже с поддержкой до и после покупки';
export const INTRO_SUBTITLE_LINE1 = 'по ценам туроператоров или ниже';
export const INTRO_SUBTITLE_LINE2 = 'с поддержкой до и после покупки';
export const INTRO_WARRANTY = '100% гарантия честных цен';
export const TYRI = 'Туры';
export const HOT = 'Горящие';
export const WHERE = 'Откуда';

// Popular Directions
export const POPULAR_TITLE = 'Популярные направления';
export const CUPRUS = 'Кипр';
export const VISA_ONLINE = 'Онлайн-виза';
export const VISA_WITHOUT = 'Без визы';
export const CUPRUS_CITIES = 'Пафос, Протарас, Лимассол, Ларнака, Айя-Напа.';
export const CUPRUS_PRICE = 'от 700 руб./чел.';
export const TURKEY = 'Турция';
export const UAE = 'ОАЭ';
export const THAILAND = 'Таиланд';
export const EGYPT = 'Египет';
export const TURKEY_PRICE = 'от 450 руб./чел.';
export const TAILAND = 'Таиланд';
export const TAILAND_CITY = 'Паттайя, Пхукет, Самуи, Ко Чанг, Краби.';
export const TAILAND_PRICE = 'от 750 руб./чел.';
export const ALL_DIRECTIONS = 'Посмотреть все направления';
export const PRICE_FROM = 'от';
export const PER_PERSON = '/чел';
export const TURKEY_DESC1 =
  'Тёплое Средиземное и Эгейское моря, песчаные пляжи, горные пейзажи и колоритные восточные базары. Турция знаменита системой all inclusive, шикарными отелями на любой вкус и древними руинами античных городов';
export const TURKEY_DESC2 =
  'Здесь легко совместить отдых у моря, активные экскурсии и выгодный шопинг. Отличный выбор для семей с детьми и молодёжных компаний.';
export const UAE_DESC1 =
  'Современные мегаполисы с сияющими небоскрёбами, впечатляющими торговыми галереями и широкими пляжами с мягким белым песком. Здесь можно прогуливаться по восточным рынкам, отправиться на сафари по дюнам или просто наслаждаться отдыхом в пятизвёздочных отелях.';
export const UAE_DESC2 =
  'Дубай, Абу-Даби и Шарджа дарят туристам огромный выбор впечатлений от аквапарков мирового уровня до увлекательных экскурсий по пустынным просторам.';
export const EGYPT_DESC1 =
  'Страна вечного солнца, где тёплый климат радует туристов почти круглый год. Египет впечатляет Красным морем с прозрачной водой и богатым подводным миром.';
export const EGYPT_DESC2 =
  'Здесь можно увидеть величественные пирамиды и бескрайние пустынные пейзажи. Отдых доступен в любое время года и будет интересен как любителям пляжного релакса, так и ценителям древней истории.';
export const THAILAND_DESC1 =
  'Таиланд завораживает белоснежными пляжами, живописными островами и богатым подводным миром, который идеально подходит для дайвинга и снорклинга.';
export const THAILAND_DESC2 =
  'Здесь можно посетить величественные буддийские храмы, побывать на колоритных рынках Бангкока и отправиться в путешествие по джунглям. Отдых в Таиланде сочетает в себе пляжное наслаждение, культурные открытия и яркую ночную жизнь.';
// Advantages
export const WHY_TOURHUNTER = 'Почему выбирают TourHunter';
export const WHY_TOURHUNTER_DESC =
  'Мы хантим лучших операторов. Вот наши сильные стороны:';
export const ADV1_TITLE = 'Покупайте онлайн и экономьте';
export const ADV1_TEXT =
  'Туры быстро заканчиваются — забронируйте онлайн по самой низкой цене, пока она доступна!';
export const ADV2_TITLE = 'Поддержка 24/7 до и после покупки';
export const ADV2_TEXT =
  'Мы всегда на связи — по телефону и в мессенджерах, готовы помочь в любое время!';
export const ADV3_TITLE = 'Честные цены без переплат';
export const ADV3_TEXT =
  'Цены на нашем сайте такие же, как у туроператоров, или даже ниже. Найдете дешевле — компенсируем вам разницу в двойном размере!';
export const ADV4_TITLE = 'Сравнивайте туры от всех операторов';
export const ADV4_TEXT =
  'Сравнивайте туры разных операторов за минуты, находите лучший вариант и экономьте время и деньги.';
// Description
export const DESC_TITLE1 = 'Подбор тура по всем операторам';
export const DESC_TITLE2 = 'онлайн:';
export const DESC_TITLE3 = 'как сделать идеальный выбор';
export const DESC1 =
  'Нашими партнерами являются самые крупные и надежные туроператоры, поэтому вы можете быть уверены в качестве приобретенного тура. Кроме того, на нашем сайте можно купить тур по самым лучшим ценам – мы предоставляем вам возможность отправиться в путешествие с лучшим соотношением цена/качество.';
export const DESC2 =
  'Выбирая отдых с TourHunter.by, вы гарантированно получаете огромный выбор путешествий для отдыха, поэтому купить путевку у нас не сложнее, чем совершать покупки в любом онлайн-магазине. Лучшие цены и первоклассное профессиональное обслуживание – гарантия вашего качественного отдыха.';
export const DESC_SECTION1_TITLE =
  'Подбор тура по всем туроператорам онлайн: как сделать идеальный выбор';
export const DESC_SECTION1_PARAGRAPHS = [
  'Современные технологии значительно изменили способ планирования путешествий. Сегодня, благодаря нашему сервису, подбор тура стал проще и быстрее, чем когда-либо.',
  'С помощью tourhunter.by вы сможете сравнить предложения от разных туроператоров, выбрать оптимальный вариант и сэкономить время и деньги. В этой статье мы рассмотрим, как правильно подбирать тур, чтобы ваш отдых стал незабываемым.',
];
export const DESC_SECTION2_TITLE =
  'Зачем использовать онлайн-сервисы для подбора тура?';
export const DESC_SECTION2_PARAGRAPHS = [
  'Онлайн-сервис tourhunter.by агрегирует информацию о турах от множества туроператоров, что позволяет вам увидеть разнообразие предложений — от бюджетных до элитных вариантов.',
  'Визуально сравнив цену на один и тот же тур у разных операторов, вы с легкостью найдете лучшее предложение и потенциально сэкономите значительную сумму.',
  'У вас есть возможность планировать свой отпуск в любое время и в любом месте, не выходя из дома! Более того, можно легко проверять наличие мест и условия проживания.',
  'Изучайте рейтинги и отзывы на отели на TripAdvisor и Booking.',
  'Если вы можете немного изменить даты своего путешествия, это часто позволяет найти более выгодные предложения.',
  'Раннее бронирование дает возможность получить больший выбор отелей и лучшие цены. Не забывайте о страховании от невылета - отличный способ обезопасить себя в случае непредвиденных ситуаций. Мы всегда рекомендуем туристам ее оформлять.',
  'Таким образом, сравнивая цены, читая отзывы и изучая предложения, вы сможете сделать осознанный выбор и насладиться долгожданным путешествием. Не упустите возможность воспользоваться нашим сервисом, чтобы ваш отпуск стал поистине незабываемым!',
];

// Search form
export const CITY_FROM = 'Город вылета:';
export const ADULTS = 'Взрослые';
export const ADULTS_FROM = 'от 18 лет';
export const KIDS_FROM_0_17 = 'ДЕТИ ОТ 0 ДО 17';
export const KIDS = 'Дети';
export const KIDS_AGE_RANGE = 'от 2 до 11 лет';
export const ADD_KID = 'Добавить ребенка';

export const BEFORE_YEAR = 'до 1 года';
export const ONE_YEAR = '1 год';
export const TWO_YEARS = '2 года';
export const THREE_YEARS = '3 года';
export const FOUR_YEARS = '4 года';
export const FIVE_YEARS = '5 лет';
export const SIX_YEARS = '6 лет';
export const SEVEN_YEARS = '7 лет';
export const EIGHT_YEARS = '8 лет';
export const NINE_YEARS = '9 лет';
export const TEN_YEARS = '10 лет';
export const ELEVEN_YEARS = '11 лет';
export const TWELVE_YEARS = '12 лет';
export const THIRTEEN_YEARS = '13 лет';
export const FOURTEEN_YEARS = '14 лет';
export const FIFTEEN_YEARS = '15 лет';
export const SIXTEEN_YEARS = '16 лет';
export const SEVENTEEN_YEARS = '17 лет';
export const KIDS_AGE_NOTE = 'Возраст на начало поездки';

export const FROM_LABEL = 'Откуда';
export const TO_LABEL = 'Страна, курорт или отель';
export const WHEN_LABEL = 'Даты вылета';
export const WHO_GO_LABEL = 'Кто едет';
export const TOURISTS_LABEL = 'Туристы';
export const NIGHTS_LABEL = 'Количество ночей';
export const DATE_LABEL = 'Интервал дат вылета';
export const HOTEL_LABEL = 'Отель';

export const FROM_ID = 'FROM';
export const TO_ID = 'TO';
export const WHEN_ID = 'WHEN';
export const TOURISTS_ID = 'TOURISTS';
export const NIGHTS_ID = 'NIGHTS';
export const HOTEL_ID = 'HOTEL';

export const SEARCH = 'ИСКАТЬ';
export const TOUR = 'ТУР';
export const SEARCH_TOUR = 'Искать тур';

// Search form nights popover
export const SELECTED_DAYS = 'Выбраны туры';
export const SELECTED_NA = 'на';
export const SELECTED_NIGHTS = 'ночей';

export const HOT_TOURS = 'Горящие туры';
export const FROM_TEXT = 'Откуда';

export const NO_HOT_RESULTS = 'Горящих туров не найдено';
